import React, { useState } from "react";
import styles from "./userInfoDropdown.module.scss";
import { NavLink } from "react-router-dom";
import BoxIcon from "../../assets/images/header/icons/box.svg";
import PersonIcon from "../../assets/images/header/icons/person.svg";
import LogoutIcon from "../../assets/images/header/icons/logout.svg";
import ExitComponent from "../pages/exit/ExitComponent";

interface HeaderDropdownProps {
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  user: any;
  translations?: any;
}

const UserInfoDropdown: React.FC<HeaderDropdownProps> = ({
  onMouseEnter,
  onMouseLeave,
  user,
  translations,
}) => {
  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState<boolean>(false);

  const handleOpenLogoutModal = (
    e?: React.MouseEvent<HTMLElement>
  ) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    setIsLogoutModalOpen(true);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLButtonElement>) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      e.stopPropagation();
      setIsLogoutModalOpen(true);
    }
  };

  const handleCloseLogoutModal = () => {
    setIsLogoutModalOpen(false);
    if (onMouseLeave) {
      onMouseLeave();
    }
  };

  const userInitial = user?.name ? user.name.trim().charAt(0).toUpperCase() : "U";
  const fullName = user?.name
    ? `${user.name} ${user?.surname || ""}`.trim()
    : (translations?.user || "İstifadəçi");

  return (
    <div
      className={styles.dropdownContainer}
      onMouseEnter={onMouseEnter}
      onMouseLeave={() => {
        if (!isLogoutModalOpen && onMouseLeave) {
          onMouseLeave();
        }
      }}
    >
      <div className={styles.userCard}>
        {/* User Profile Header */}
        <div className={styles.userHeader}>
          <div className={styles.avatarCircle} aria-hidden="true">
            <span>{userInitial}</span>
          </div>
          <div className={styles.userInfo}>
            <p className={styles.userName}>{fullName}</p>
            <span className={styles.userSubtext}>
              {user?.email || user?.number || translations?.control_account || "Hesabın idarəsi"}
            </span>
          </div>
        </div>

        <div className={styles.divider} />

        {/* Navigation Links */}
        <ul className={styles.menuList}>
          <li>
            <NavLink to="/accountInfo" className={styles.menuLink} tabIndex={0}>
              <div className={styles.iconWrapper}>
                <img src={PersonIcon} alt="" aria-hidden="true" />
              </div>
              <span className={styles.linkText}>
                {translations?.my_info || "Hesab məlumatlarım"}
              </span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/orders" className={styles.menuLink} tabIndex={0}>
              <div className={styles.iconWrapper}>
                <img src={BoxIcon} alt="" aria-hidden="true" />
              </div>
              <span className={styles.linkText}>
                {translations?.my_orders || "Sifarişlərim"}
              </span>
            </NavLink>
          </li>
        </ul>

        <div className={styles.divider} />

        {/* Logout Action */}
        <div
          className={styles.logoutWrapper}
          onClick={handleOpenLogoutModal}
          onMouseDown={(e) => e.stopPropagation()}
        >
          <button
            type="button"
            onClick={handleOpenLogoutModal}
            onMouseDown={(e) => e.stopPropagation()}
            onKeyDown={handleKeyDown}
            className={styles.logoutBtn}
            tabIndex={0}
            aria-label={translations?.log_out || "Çıxış"}
          >
            <div
              className={styles.logoutIconWrapper}
              aria-hidden="true"
              onClick={handleOpenLogoutModal}
            >
              <img src={LogoutIcon} alt="" aria-hidden="true" />
            </div>
            <span
              className={styles.logoutText}
              onClick={handleOpenLogoutModal}
            >
              {translations?.log_out || "Çıxış"}
            </span>
          </button>
        </div>
      </div>

      {isLogoutModalOpen && (
        <ExitComponent
          isOpen={isLogoutModalOpen}
          onClose={handleCloseLogoutModal}
        />
      )}
    </div>
  );
};

export default UserInfoDropdown;
